import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

// A fresh, read-only labels hook for shared/ClientAccountList (ID-13350). Deliberately NOT a move of
// client-dashboard's useLabels: that one also owns addLabel/deleteLabel, branches on host-only
// clientAccountsEnabled data, and pops its own AlertDialog (a pre-rule pattern) — and has six consumers.
// The list only reads the client-account label list for its filter dropdown, so this hook does just that,
// the convention-correct way: it fetches client-account labels, logs and rethrows on failure, and surfaces
// no UI itself — the consumer catches and surfaces. A follow-up ticket migrates the legacy hook's other
// consumers onto shared and retires the client copy.
export default function useLabels() {
  const api = useApi();
  const [labels, setLabels] = useState<string[]>([]);
  const [fetching, setFetching] = useState(false);

  async function fetchLabels() {
    try {
      setFetching(true);
      const res = await api.fetchClientAccountLabels({});

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      const labelList = res.Labels.map((label) => label.Label);
      setLabels(labelList);

      return labelList;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { labels, fetching, fetchLabels };
}
